import { Fields } from '../../types';

export const getFieldOptions = <T extends string>(fields: Fields<T>, fieldKey: string) => {
  const field = fields.find(({ key }) => fieldKey === key)!
  return field.fieldType.type === 'select' || field.fieldType.type === 'input' && field.fieldType.options ? (field.fieldType.options??[]) : []
}

export const getFieldOptionAlternates = <T extends string>(fields: Fields<T>, fieldKey: string) => {
  const field = fields.find(({ key }) => fieldKey === key)!
  return field.fieldType.type === 'select' || field.fieldType.type === 'input' && field.fieldType.alternateMatches ? (field.fieldType.alternateMatches??[]) : []
}